export enum CategoryType {
  Post = 'Post',
  LandingPage = 'LandingPage',
}
